import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const userById = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.USER.GET_USER_BY_ID,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
